import { useTranslation } from "react-i18next"
import { Link } from "wouter"
import { LanguageSwitcher } from "@/components/LanguageSwitcher"
import { Logo } from "@/components/Logo"

export const PublicLayout = ({ children }: { children: React.ReactNode }) => {
    const { t } = useTranslation()

    return (
        <div className="min-h-screen flex flex-col">
            <header className="border-b bg-card px-6 py-4">
                <div className="max-w-5xl mx-auto flex items-center justify-between">
                    <Link to="/"><Logo variant="color" height={32} /></Link>
                    <div className="flex items-center gap-4">
                        <Link
                            to="/for-owners"
                            className="hidden sm:inline text-xs font-black uppercase tracking-widest text-slate-400 hover:text-slate-600 transition-colors"
                        >
                            {t("layout.public.adminZone")}
                        </Link>
                        <LanguageSwitcher />
                    </div>
                </div>
            </header>
            <main className="flex-1 px-6 py-8">
                <div className="max-w-5xl mx-auto">
                    {children}
                </div>
            </main>
            {/* pb-28 on mobile clears the fixed bottom bar used on reservation
                detail pages — without it the footer is hidden under the bar. */}
            <footer className="border-t bg-card px-6 py-4 pb-28 sm:pb-4 text-center text-sm text-muted-foreground space-y-1">
                <div>{t("layout.public.footer", { year: new Date().getFullYear() })}</div>
                <div className="text-xs">
                    <a href={t("layout.public.creditUrl")} target="_blank" rel="noopener noreferrer" className="hover:text-slate-700 transition-colors">
                        {t("layout.public.credit")}
                    </a>
                </div>
            </footer>
        </div>
    )
}
